import { t as defMathOp } from './codegen-df7bb22c.js';

const isNumber = (x) => typeof x === "number";

const [add, add2, add3, add4] = defMathOp("+");

export { add3 as a, add2 as b, add as c, isNumber as i };
